import { Component, inject, output, ChangeDetectionStrategy } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { HighlightType } from './highlights';
import { MatChipsModule } from '@angular/material/chips';
import { NgOptimizedImage } from '@angular/common';
import { HighlightService } from './highlight.service';
import { MarkdownViewerComponent } from '../../../../settings/shared-settings/markdown-viewer/markdown-viewer.component';

@Component({
  selector: 'app-help-drawer',
  imports: [
    MatDividerModule,
    MatIconModule,
    MatButtonModule,
    MatChipsModule,
    NgOptimizedImage,
    MarkdownViewerComponent,
  ],
  templateUrl: './help-drawer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './help-drawer.component.scss',
})
export class HelpDrawerComponent {
  protected readonly HighlightType = HighlightType;
  highlightService = inject(HighlightService);
  closeDrawer = output();
  highlights = this.highlightService.highlights;
}
